import { render } from "./CrudSelect.vue?vue&type=template&id=964e9f3e"
import script from "./CrudSelect.vue?vue&type=script&lang=js"
export * from "./CrudSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__